<template>
  <div>
    <v-simple-table v-if="response">
      <template v-slot:default>
        <tbody>
          <tr>
            <td>カードNo</td>
            <td>XXXX-XXXX-XXXX-{{ response.last4 }}</td>
          </tr>
          <tr>
            <td>有効期限</td>
            <td>{{ response.year }}/{{ response.month }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-checkbox
      v-if="response"
      v-model="newCardChecked"
      label="新しいクレジットカードを設定する"
    />

    <div
      v-if="newCardChecked || !response"
      class="credit-card-inputs"
      :class="{ complete }"
      style="display: inline;background-color: #666666;"
    >
      <h6 class="mb-1">
        カード番号
      </h6>
      <card-number
        ref="cardNumber"
        class="stripe-element card-number"
        :stripe="stripe"
        :options="stripeOptions"
        @change="number = $event.complete"
      />
      <h6 class="mt-4 mb-1">
        有効期限
      </h6>
      <card-expiry
        ref="cardExpiry"
        class="stripe-element card-expiry"
        :stripe="stripe"
        :options="stripeOptions"
        @change="expiry = $event.complete"
      />
      <h6 class="mt-4 mb-1">
        セキュリティコード※クレジットカード裏面に記載された3桁の番号
      </h6>
      <card-cvc
        ref="cardCvc"
        class="stripe-element card-cvc"
        :stripe="stripe"
        :options="stripeOptions"
        @change="cvc = $event.complete"
      />

      <div class="d-flex mt-3">
        <img
          style="width: 40px; height: 100%"
          src="../assets/visa.png"
        >
        <img
          class="ml-1"
          style="width: 40px; height: 100%"
          src="../assets/jcb.png"
        >
        <img
          class="ml-1"
          style="width: 40px; height: 100%"
          src="../assets/master.png"
        >
        <img
          class="ml-1"
          style="width: 40px; height: 100%"
          src="../assets/american_express.png"
        >
      </div>

      <v-card-actions v-if="response">
        <v-spacer />
        <v-btn
          color="accent"
          class="mt-4 px-8"
          :disabled="!complete"
          @click="showNewCardConfirm()"
        >
          クレジットカード変更確認
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </div>

    <v-dialog
      v-model="newCardConfirm"
      max-width="450"
    >
      <v-card class="mx-auto">
        <v-card-title>
          クレジットカード変更確認
        </v-card-title>

        <v-card-subtitle class="mt-3">
          <ul>
            <li>カードNo：XXXX-XXXX-XXXX-{{ cardObject ? cardObject.last4 : '' }}</li>
            <li>有効期限：{{ cardObject ? `${cardObject.year}/${cardObject.month}` : '' }}</li>
          </ul>
        </v-card-subtitle>

        <v-card-actions>
          <v-list-item class="grow">
            <v-row
              align="center"
              justify="end"
            >
              <v-btn
                text
                @click="newCardConfirm = false"
              >
                キャンセル
              </v-btn>

              <v-btn
                text
                @click="executeUpdateCard()"
              >
                完了
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {CardCvc, CardExpiry, CardNumber, createToken} from 'vue-stripe-elements-plus';
  import axios from "axios";
  import config from "@/const";
  import firebase from "firebase";

  export default {
    name: 'CardInput',
    components: {
      CardNumber, CardExpiry, CardCvc,
    },
    data() {
      return {
        newCardChecked: false,
        complete: false,
        number: false,
        expiry: false,
        cvc: false,
        //テスト用キー
        // stripe: 'pk_test_51HFfWhKEBlYZKrPlUNdPpjTTlyEaak5JVyGAMobDA41ycIKC4TjAhZaJv3H9aftNuHTlLZUaivs4WS1qeSUfbMzM00WRDfvxAZ',
        stripe:'pk_live_51HFfWhKEBlYZKrPlqDQQYgMWVRwsj4rFG5CQ31ZdtF7lacX6DgTScCZTGTcBStmjTlaDC9y82yPVwYPUN2x3rWj000CCBO2Sb1',
        response: null,
        stripeOptions: {},
        token: {},
        cardObject: {},
        newCardConfirm: false,
      };
    },
    watch: {
      number() {
        this.update()
      },
      expiry() {
        this.update()
      },
      cvc() {
        this.update()
      }
    },
    mounted() {
      this.executeCard();
    },
    methods: {
      update() {
        this.complete = this.number && this.expiry && this.cvc;
        if (this.number) {
          if (!this.expiry) {
            this.$refs.cardExpiry.focus()
          } else if (!this.cvc) {
            this.$refs.cardCvc.focus()
          }
        } else if (this.expiry) {
          if (!this.cvc) {
            this.$refs.cardCvc.focus()
          } else if (!this.number) {
            this.$refs.cardNumber.focus()
          }
        }
        // カードtoken取得
        if (this.complete) {
          createToken().then(data => {
            this.token = data.token;
            this.cardObject = {
              last4: this.token.card.last4,
              brand: this.token.card.brand,
              year: this.token.card.exp_year,
              month: this.token.card.exp_month,
              id: this.token.id
            };
            this.$emit('changeCard', this.cardObject);
          }).catch(() => {
            alert("入力情報の処理に失敗しました。不正な入力です。");
          })
        }
      },
      async executeCard() {
        const user = firebase.auth().currentUser;
        this.userToken = await user.getIdToken(false);
        const response = await axios.get(config.API_URL + "auth/card", {
          headers: {"X-Firebase-Auth": this.userToken},
        });
        this.response = response.data;
        this.cardObject = this.response;
        this.$emit('changeCard', this.response);
      },
      async showNewCardConfirm() {
        const user = firebase.auth().currentUser;
        user.getIdToken(false).then(token => {
          this.userToken = token;
          this.newCardConfirm = true;
        }).catch(reason => {
          alert("ユーザー認証でエラーが発生しました。画面をリロードしてお試しください")
        })
      },
      async executeUpdateCard() {
        this.newCardConfirm = false;
        await axios.patch(`${config.API_URL}auth/source/${this.cardObject.id}`, {},
          {
            headers: {"X-Firebase-Auth": this.userToken},
          }).then(value => {
        });
        this.newCardChecked = false;
        this.executeCard();
      },
    }
  }
</script>
<style>
    /*.credit-card-inputs.complete {*/
        /*border: 2px solid green;*/
    /*}*/

    .card-number {
        width: 204px;
        padding: 8px;
        margin-bottom: 4px;
        border: 1px solid #BBBBBB;
        border-radius: 4px;
    }

    .card-expiry {
        width: 100px;
        padding: 8px;
        margin-bottom: 4px;
        border: 1px solid #BBBBBB;
        border-radius: 4px;
    }

    .card-cvc {
        width: 100px;
        padding: 8px;
        margin-bottom: 4px;
        border: 1px solid #BBBBBB;
        border-radius: 4px;
    }
</style>
